<template>
<b-card header="Billing" header-bg-variant=primary>
  <b-alert :show=amountIncreased variant=danger class="mb-0 py-0 small">
    You cannot increase the amount on a CC payment!
  </b-alert>
  <b-alert :show=totalsMismatch variant=danger class="mb-0 py-0 small">
    Your payments don't add up to the order total!
  </b-alert>
  <b-form-row>
    <b-col cols=4>
      <b-form-row class='my-1 align-items-center' v-for="payment in order.payments" :key="payment.tenderId">
        <b-col cols=4>
          <strong>
            <data-merger :dict=payment.method />
          </strong>
        </b-col>
        <b-col cols=2><label>Amount</label></b-col>
        <b-col>
          <input-merger :dict=payment.amount type=number :step=0.01 :disabled=canChangeAmount />
        </b-col>
        <b-col cols=* v-if="isPurchaseOrder"><label>PO #</label></b-col>
        <b-col v-if="isPurchaseOrder">
          <input-merger :dict=order.poNum :disabled=disabled  />
        </b-col>
        <b-col cols=* v-if=isGiftCard><label>Card #</label></b-col>
        <b-col v-if=isGiftCard>
          <input-merger :dict=payment.token :disabled=disabled />
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col cols=4 />
        <b-col cols=2><label>Total:</label></b-col>
        <b-col class='pt-1 text-right'>
          <span class='text-monospace'>{{paymentSum | formatDollars}}</span>
        </b-col>
      </b-form-row>
      <hr class=darkhr />
      <b-form-row>
        <b-col><label class='my-0'>Items</label></b-col>
        <b-col class='text-right'><span class='text-monospace'>1234.56</span></b-col>
      </b-form-row>
      <b-form-row>
        <b-col><label class='my-0'>Shipping</label></b-col>
        <b-col class='text-right'><span class='text-monospace'>7890.12</span></b-col>
      </b-form-row>
      <b-form-row>
        <b-col><label class='my-0'>Discounts</label></b-col>
        <b-col class='text-right'><span class='text-monospace'>- 1900.00</span></b-col>
      </b-form-row>
      <hr class='darkhr mt-0 mb-1'/>
      <b-form-row>
        <b-col><label class='my-0'><strong>Subtotal</strong></label></b-col>
        <b-col class='text-right'><span class='text-monospace'><strong>123.45</strong></span></b-col>
      </b-form-row>
      <b-form-row>
        <b-col><label class='my-0'>Tax</label></b-col>
        <b-col class='text-right'><span class='text-monospace'>43456.34</span></b-col>
      </b-form-row>
      <hr class='darkhr mt-0 mb-1'/>
      <b-form-row>
        <b-col><label class='my-0'><strong>Total</strong></label></b-col>
        <b-col class='text-right'><span class='text-monospace'><strong>9999.88</strong></span></b-col>
      </b-form-row>
    </b-col>
    <b-col>
      <b-form-row class='mt-1'>
        <b-col>
          <b-alert show variant=warning class='py-2 small'>Taxes? Taxes.</b-alert>
        </b-col>
      </b-form-row>
      <address-form :address=order.billingAddress />
    </b-col>
  </b-form-row>

</b-card>
</template>

<script>
import InputMerger from '../../utility/InputMerger'
import DataMerger from '../../utility/DataMerger'
import AddressForm from './AddressForm'

export default {
  props: {
    order: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
    };
  },
  components: {
    InputMerger,
    DataMerger,
    AddressForm
  },
  computed: {
    paymentSum() { return this.order.payments.reduce((m,i) => m + i.amount.edited, 0) }
  },
  methods: {
  }
}
</script>

<style>
.darkhr {
  border-top-color: rgba(0,0,0,0.7)
}
</style>


// WEBPACK FOOTER //
// src/components/sales-order/edit-order-2/BillingEditor.vue